import React from "react";
import { Field, inputCls } from "@/components/common";
import { RING_SIZES } from "@/lib/ringSizes";

const METALS = ["Yellow gold", "White gold", "Rose gold", "Platinum"];
const SHAPES = ["Round", "Oval", "Emerald", "Pear", "Cushion", "Elongated cushion", "Radiant", "Princess", "Marquise", "Asscher", "Heart"];
const BUDGETS = ["Under $3,000", "$3,000–$5,000", "$5,000–$8,000", "$8,000–$12,000", "$12,000–$20,000", "$20,000+"];
export const EMPTY_PLAN = { ring_size: "", metal: "", shape: "", budget: "", style: "" };

const Pick = ({ label, k, opts, none, plan, set }: any) => (
  <Field label={label}>
    <select value={plan[k]} onChange={(e) => set({ ...plan, [k]: e.target.value })} className={inputCls} data-testid={`plan-${k.replace("_", "-")}-select`}>
      <option value="">{none}</option>
      {opts.map((o: string) => <option key={o}>{o}</option>)}
    </select>
  </Field>
);

export const planSummary = (p: any) => p ? [p.ring_size && `Size ${p.ring_size}`, p.metal, p.shape, p.budget, p.style && `“${p.style}”`].filter(Boolean).join(" · ") : "";

export function ProposalPlanning({ plan, set }: { plan: any; set: (v: any) => void }) {
  return (
    <div className="border-t border-neutral-200 pt-5 space-y-5" data-testid="proposal-planning">
      <div><p className="eyebrow">Proposal planning</p><p className="text-xs text-neutral-600 mt-1">Optional — only you and your jeweler will see this.</p></div>
      <div className="grid sm:grid-cols-2 gap-5">
        <Pick label="Ring size guess" k="ring_size" none="Not sure" plan={plan} set={set} opts={RING_SIZES.map((s) => `${s.uk} (US ${s.us})`)} />
        <Pick label="Preferred metal" k="metal" none="Not sure" plan={plan} set={set} opts={METALS} />
        <Pick label="Favourite diamond shape" k="shape" none="Not sure" plan={plan} set={set} opts={SHAPES} />
        <Pick label="Budget range (AUD)" k="budget" none="Prefer not to say" plan={plan} set={set} opts={BUDGETS} />
      </div>
      <Field label="Style hints"><textarea rows={2} maxLength={500} value={plan.style} onChange={(e) => set({ ...plan, style: e.target.value })} placeholder="e.g. loves vintage, mostly wears silver, works with her hands" className={inputCls} data-testid="plan-style-input" /></Field>
    </div>
  );
}
